import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import { Intersect } from 'vuetify/lib/directives';

Vue.use(Vuetify)

export default new Vuetify({
  directives: {
    Intersect,
  },
  theme: {
    themes: {
      light: {
        primary: '#234177', // #E53935
        red: '#9C1B38', // #E53935
        green: '#27AE60', // #E53935
        greenLight: '#52C41A', // #E53935
        grey: '#D1D1D1', // #E53935
      },
    },
  },
})
